import React, { Component } from 'react';
import './styles.css';

class BodyLeftRow extends Component {
	render() {
		return (
			<div className="sales-test-layout-body-left-row">
				{this.props.children}
			</div>
		);
	}
}
export default BodyLeftRow;
